import React from "react";
import "./Home.css"; // Assuming you have a CSS file for styling

const Home = () => {
    return (
        <div style={{ padding: "2em", textAlign: "center" }}>
            <h1>Welcome to NSTU Teacher Profiles</h1>
            <p>Explore profiles of distinguished faculty members.</p>
            <a class="btn btn-lg btn-secondary" href="/teacher/1" style={{ marginTop: "4rem"}}>
                View Sample Profile
            </a>
        </div>
    );
};

export default Home;
